import React, { useEffect, useState } from "react";
import { picture } from "./look";

const SLIDE_MS = 5000;

export default function BannerStrip({ block }) {
  const banners = block.rows;
  const sliding = banners.length > 1;
  const ids = banners.map((banner) => banner.id).join();
  const [step, setStep] = useState({ index: 0, animate: false });

  useEffect(() => {
    setStep({ index: 0, animate: false });
    if (!sliding) return undefined;
    const timer = setInterval(
      () => setStep((s) => (s.index >= banners.length ? { index: 0, animate: false } : { index: s.index + 1, animate: true })),
      SLIDE_MS,
    );
    return () => clearInterval(timer);
  }, [ids, sliding, banners.length]);

  // The first banner is repeated at the end so the last one slides forward into it, like the app's loop.
  const slides = sliding ? [...banners, banners[0]] : banners;
  const settle = () => step.index >= banners.length && setStep({ index: 0, animate: false });

  return (
    <div style={{ margin: "4px 0", overflow: "hidden" }}>
      <div
        data-testid={`banner-strip-${block.placement}`}
        onTransitionEnd={settle}
        style={{
          display: "flex",
          transform: `translateX(-${step.index * 100}%)`,
          transition: step.animate ? "transform 600ms ease" : "none",
        }}
      >
        {slides.map((banner, index) => (
          <div key={`${banner.id}-${index}`} style={{ flex: "0 0 100%", padding: "0 11px" }}>
            <img src={picture(banner.image)} alt=""
              style={{ display: "block", width: "100%", height: 170, objectFit: "cover", borderRadius: 5, background: "#E6E6E6" }} />
          </div>
        ))}
      </div>
    </div>
  );
}
